import styled from "styled-components"
import media from "styled-media-query"

export const PaginationWrapper = styled.section`
  align-items: center;
  border-top: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.opaque};
  display: flex;
  font-weight: 400;
  height: 5em;
  padding: 1.5rem 0;
  justify-content: space-between;
  text-align: center;

  a {
    color: ${props => props.theme.colors.opaque};
    min-width: 4em;
    text-decoration: none;
    transition: color 0.5s;

    ${media.greaterThan("medium")`
        min-width: 8em;
    `}

    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
  }

  p {
    margin-bottom: 0;
    min-width: 4em;

    ${media.greaterThan("medium")`
        min-width: 8em;
    `}
  }
`
